exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cfd-wrapper[data-v-7903350b]{overflow-x:auto}.cfd-table[data-v-7903350b]{display:table;width:100%}.cfd-tbody[data-v-7903350b]{display:table-row-group}.cfd-scroller[data-v-7903350b]{position:fixed;z-index:10;overflow:auto;bottom:0}.cfd-scroller.is-hidden[data-v-7903350b]{display:none}.cfd-scroller-content[data-v-7903350b]{height:1px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7903350b","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/desktop/InstrumentTable.vue
// module id = 142
// module chunks = 0